export const changeProductsView = () => {
  const viewItems = document.querySelectorAll(".products-view__item");

  const getCookie = (name) =>
      document.cookie
          .split("; ")
          .find((row) => row.startsWith(`${name}=`))
          ?.split("=")[1];

  const setCookie = (name, value, days = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  };

  const updateActiveItem = (columns) => {
    viewItems.forEach((item) => {
      item.classList.toggle(
          "active",
          item.getAttribute("data-shop-columns") === columns
      );
    });
  };

  const currentColumns = getCookie("shop_columns");
  if (currentColumns) {
    updateActiveItem(currentColumns);
  }

  viewItems.forEach((item) => {
    item.addEventListener("click", () => {
      const columns = item.getAttribute("data-shop-columns");

      if (getCookie("shop_columns") === columns) return;

      setCookie("shop_columns", columns);
      location.reload();
    });
  });
};
